import { GET_DETAIL_DOC_NOTULENSI, GET_LIST_NOTULENSI, GET_SHARED_NOTULENSI } from "shared/constants/ActionTypes";

const initialState = {
    documents: {},
    detailDoc: {
        result: null
    },
}

const notulensiReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_LIST_NOTULENSI:
            return {
                ...state,
                documents: action.payload
            }
        case GET_SHARED_NOTULENSI:
            return {
                ...state,
                documents: action.payload
            }
        case GET_DETAIL_DOC_NOTULENSI:
            return {
                ...state,
                detailDoc: action.payload
            }
        default:
            return {
                ...state
            }
    }
};

export default notulensiReducer;